<div class="login-auth-dialog">
  <p class="login-auth-help" translate>label_forgot_password_help</p>

  <form [formGroup]="editforgotForm" autocomplete="off" class="login-auth-form">
    <div class="login-field">
      <label for="forgotPasswordEmail" translate>label_email</label>
      <div class="login-input-icon">
        <img class="input-prefix-icon" src="/assets/images/temp/mail.svg" alt="" aria-hidden="true" />
        <input formControlName="username" id="forgotPasswordEmail" type="email" pInputText
          class="has-prefix-icon" autocomplete="off"
          [placeholder]="'placeholder_enter_email' | translate"
          [readonly]="isSubmitting" />
      </div>
      <div class="form-errors"
        *ngIf="editforgotForm.controls.username.errors && (editforgotForm.controls.username.dirty || editforgotForm.controls.username.touched)">
        <div *ngIf="editforgotForm.controls.username.errors.required" translate>error_email_is_required</div>
        <div *ngIf="editforgotForm.controls.username.errors.pattern" translate>error_invalid_email</div>
      </div>
    </div>

    <div class="login-auth-actions">
      <button pButton appRipple type="button" class="login-auth-primary"
        [label]="'label_send' | translate"
        [disabled]="!editforgotForm.valid || isSubmitting"
        (click)="changePassword($event)"></button>
      <button pButton appRipple type="button" class="login-auth-secondary p-button-outlined"
        [label]="'label_cancel' | translate"
        [disabled]="isSubmitting"
        (click)="closeEditForgot($event)"></button>
    </div>
  </form>
</div>
